
















import Vue from 'vue';
import Component from 'vue-class-component';

import { MetaInfo } from 'vue-meta';

/** 404 page */
@Component
export default class NotFound extends Vue {
	metaInfo(): MetaInfo {
		return {
			title: this.$t('views.notFound.meta.title') as string,
			meta: [
				{
					name: 'description',
					content: this.$t('views.notFound.meta.description') as string
				}
			]
		};
	}
}
